<ng-template #content let-modal>
  @if (showDismiss && modalType !== 'showWhereUsedTree') {
    <div class="modal-header">
      <div class="col-md-12">
        @if (!imageSource) {
          <span class="modal-title">{{ modalTitle }}</span>
        }
        <button class="btn float-end" (click)="closeModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
  }
  <div class="modal-body text-center">
    @if (modalMessage) {
      <span>{{ modalMessage }}</span>
    }
    <ng-content></ng-content>

    <!-- if the is a special logic required in the display of the modal content, it has to be injected bellow -->
    @if (modalType !== '') {
      <div>
        <div>
          @switch (modalType) {
            @case ('replacements') {
              <div>
                <app-replacements-table [id]="modalTableId" [showPaginator]="false">
                </app-replacements-table>
              </div>
            }
            @case ('svhcItems') {
              <div>
                <app-svhc-items [id]="modalTableId" [showPaginator]="false">
                </app-svhc-items>
              </div>
            }
            @case ('manufacturingLocations') {
              <div
                class="manufacturing-locations-modal text-start"
                >
                @if (
                  app.manufacturer.currentManufacturer[
                  'manufacturer.manufacturingLocations'
                  ]?.length === 0
                  ) {
                  <div
                    class="manufacturing-locations-empty text-center"
                    >
                    {{ app.text.app.noResults }}
                  </div>
                }
                @if (
                  app.manufacturer.currentManufacturer[
                  'manufacturer.manufacturingLocations'
                  ]?.length > 0
                  ) {
                  <div
                    >
                    <div class="manufacturing-locations-summary">
                      <div class="manufacturing-locations-summary__icon">
                        <i class="fa fa-location-dot" aria-hidden="true"></i>
                      </div>
                      <strong>
                        {{
                        app.manufacturer.currentManufacturer[
                        'manufacturer.manufacturingLocations'
                        ].length
                        }}
                        locations
                      </strong>
                      <span class="manufacturing-locations-summary__divider"></span>
                      <span>
                        {{
                        app.manufacturer.currentManufacturer[
                        'manufacturer.manufacturingLocations'
                        ][0].CountryName
                        }}
                        ·
                        {{
                        app.manufacturer.currentManufacturer[
                        'manufacturer.manufacturingLocations'
                        ][0].CityName
                        }}
                      </span>
                    </div>
                    <div class="manufacturing-locations-list">
                      @for (
                        location of
                        app.manufacturer.currentManufacturer[
                        'manufacturer.manufacturingLocations'
                        ]; track
                        location; let index = $index) {
                        <article
                          class="manufacturing-location-card"
                          >
                          <div class="manufacturing-location-card__marker">
                            <span>{{ index + 1 }}</span>
                          </div>
                          <div class="manufacturing-location-card__content">
                            <h4 class="manufacturing-location-card__title">
                              <span>{{ getFacilityTypeLabel(location.Facilitytype) }}</span>
                                <span class="manufacturing-location-card__country">
                                  · {{ location.CountryName }}
                                </span>
                              </h4>
                              <div class="manufacturing-location-card__fields">
                                <div class="manufacturing-location-card__field">
                                  <span>City</span>
                                  <strong>{{ location.CityName }}</strong>
                                </div>
                                <div class="manufacturing-location-card__field">
                                  <span>Address</span>
                                  <strong>{{ location.Address }}</strong>
                                </div>
                                <div class="manufacturing-location-card__field">
                                  <span>Site Owner</span>
                                  <strong>{{ location.SiteOwner }}</strong>
                                </div>
                              </div>
                            </div>
                          </article>
                        }
                      </div>
                      <footer class="manufacturing-locations-footer">
                        <span>
                          {{
                          app.manufacturer.currentManufacturer[
                          'manufacturer.manufacturingLocations'
                          ].length
                          }}
                          manufacturing locations
                        </span>
                      </footer>
                    </div>
                  }
                </div>
              }
              @case ('pcnHistory') {
                <div>
                  <app-pcn-history-table [id]="modalTableId" [showPaginator]="false">
                  </app-pcn-history-table>
                </div>
              }
              @case ('showWhereUsed') {
                <div>
                  <app-where-used-in></app-where-used-in>
                </div>
              }
              @case ('showWhereUsedTree') {
                <div>
                  <app-where-used-tree
                    [customer]="whereUsedCustomer"
                    [partNumber]="whereUsedPartNumber"
                  ></app-where-used-tree>
                </div>
              }
              @case ('showListOfCases') {
                <div>
                  <app-list-opened-cases></app-list-opened-cases>
                </div>
              }
              @case ('dueDateField') {
                <div>
                  <app-field
                    [model]="app.thread.thread"
                    [field]="app.fieldId.thread.dueDate"
                  ></app-field>
                </div>
              }
              @case ('wf-automation') {
                <div>
                  <app-wf-automation></app-wf-automation>
                </div>
              }
              @case ('wf-automation-new') {
                <div>
                  <app-wf-automation></app-wf-automation>
                </div>
              }
              @case ('vehicle-responsible-new') {
                <div>
                  <app-vehicle-responsible></app-vehicle-responsible>
                </div>
              }
              @case ('vehicle-responsible') {
                <div>
                  <app-vehicle-responsible></app-vehicle-responsible>
                </div>
              }
              @case ('image') {
                <div>
                  @if (imageUrl) {
                    <img src="{{ imageUrl }}" class="img-responsive" />
                  }
                </div>
              }
              @case ('userManuals') {
                <div>
                  <app-documentation></app-documentation>
                </div>
              }
              @case ('assignedTo') {
                <div>
                  <app-assigned-to></app-assigned-to>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
    @if (showButtons) {
      <div class="modal-footer">
        <button class="btn btn-cancel text-center m-1" (click)="dismiss()">
          {{ getButtonsText("dismiss") }}
        </button>
        @if (!showItemFields) {
          <button
            class="btn btn-ok text-center m-1"
            (click)="modal.close('OK')"
            [disabled]="isDisabled()"
            >
            {{ getButtonsText("save") }}
          </button>
        }
      </div>
    }
    @if (showOnlyOkBtn) {
      <div class="modal-footer">
        <button class="btn btn-cancel text-center m-1" (click)="dismiss()">
          {{ getButtonsText("save") }}
        </button>
      </div>
    }
  </ng-template>
